export default [
  {
    path: "goods/deficit/list",
    name: "DeficitList",
    component: () => import("@/pages/goods/DeficitList.vue"),
    meta: {
      title: "商品盘亏表",
      requireAuth: true,
    },
  },
  {
    path: "goods/deficit/review/list",
    name: "DeficitReviewList",
    component: () => import("@/pages/goods/DeficitReviewList.vue"),
    meta: {
      title: "盘亏审核列表",
      requireAuth: true,
    },
  },
  {
    path: "goods/deficit/review/detail/:id",
    name: "DeficitReviewDetail",
    component: () => import("@/pages/goods/DeficitReviewDetail.vue"),
    meta: {
      title: "盘亏审核详情",
      requireAuth: true,
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/routes/goods.js